
// @vendor
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');

// @Commons
const { formatText } = require('core/i18n').i18n;
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @actions
const cardChargeActions = require('actions/cardCharge');
const cardPeriodicLoadsActions = require('actions/cardPeriodicLoads');

// @components
const CardCharge = require('components/cards/cardCharge/cardCharge');
const CardDetailsSidebar = require('components/cards/cardDetailsSidebar/cardDetailsSidebar');
const CardChargeSuccessStep = require('components/cards/cardChargeSteps/cardChargeSuccessStep/cardChargeSuccessStep');
const CardChargeErrorStep = require('components/cards/cardChargeSteps/cardChargeErrorStep/cardChargeErrorStep');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');
const CardHeaderDetails = require('components/cards/cardHeaderDetails/cardHeaderDetails');

// @utilities
const { cardConstants } = require('utilities/accessHelperConditions/cards');
const AccessHelper = require('utilities/accessHelper');
const { isEmpty } = require('lodash');

// @constants
const { GRAPHIC_TUTOR_TYPE_4 } = require('constants/index');

class CardChargeEditView extends React.Component {
    componentDidMount() {
        const {
            cardPeriodicLoads,
            editCardChargeView,
            getPeriodicLoadsList,
            history,
            immCards,
            match: { params: { cardId, scheduleTransferId } },
            requestECardInfo
        } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);

        AccessHelper.allowAccess(cardConstants.CARD_CHARGE, { immCard }, history);
        requestECardInfo(cardId);
        if (cardPeriodicLoads.get('byOrder').size === 0 || isEmpty(cardPeriodicLoads.get('byId'))) {
            getPeriodicLoadsList(immCard);
        } else {
            const periodicLoadData = cardPeriodicLoads.getIn(['byId', scheduleTransferId]);
            editCardChargeView(periodicLoadData);
        }
    }

    componentWillReceiveProps(nextProps) {
        const { cardPeriodicLoads, editCardChargeView, match: { params: { scheduleTransferId } } } = this.props;
        const { cardPeriodicLoads: nextCardPeriodicLoads } = nextProps;
        const isCurrentPropsData = cardPeriodicLoads.get('byOrder').size === 0 || isEmpty(cardPeriodicLoads.get('byId'));
        const isNextPropsData = nextCardPeriodicLoads.get('byOrder').size === 0 || isEmpty(nextCardPeriodicLoads.get('byId'));
        if (isCurrentPropsData !== isNextPropsData) {
            const periodicLoadData = nextCardPeriodicLoads.getIn(['byId', scheduleTransferId]);
            editCardChargeView(periodicLoadData);
        }
    }

    componentWillUnmount() {
        this.props.clearRequest();
    }

    render() {
        const {
            cardPeriodicLoads,
            flagBasedFeatures,
            immAccounts,
            immCardCharge,
            immCards,
            match: { params: { cardId } },
            postChange,
            requestECardInfo,
            setVisibleStep,
            setWillCancel,
            validateStep
        } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);
        const isPeriodicTransfer = flagBasedFeatures.get('hb-card-periodic-trfr-enabled');
        const titleEditable = formatText('editCardCharge-title');
        const type = immCard.get('type');
        const subtitleLeft = formatText(`cards-${type}`);
        const subtitleRight = immCard ? immCard.getIn(['alias', 'current']).toUpperCase() : '';
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-cards'),
                url: '/myprofile/cards'
            },
            {
                text: immCard ? immCard.getIn(['alias', 'current']) : '',
                url: `/myprofile/cards/${cardId}/movements`
            },
            {
                text: formatText('breadcrumb-cardPeriodicLoads'),
                url: `/myprofile/cards/${cardId}/periodic-loads`
            },
            {
                text: formatText('breadcrumb-editChargeView')
            }
        ];
        const tutorial = (
            <TutorialLauncher
                type={GRAPHIC_TUTOR_TYPE_4}
                title={formatText('editCardCharge-title')}
            />
        );
        let bodyContent;
        if (cardPeriodicLoads.get('getLoadsListFetch')) {
            bodyContent = <LoadingSection />;
        } else if (immCardCharge.get('submitSuccessful')) {
            bodyContent = (
                <CardChargeSuccessStep
                    immCard={immCard}
                    immCardCharge={immCardCharge}
                    loading={immCardCharge.get('isFetching')}
                    requestEcardInfo={requestECardInfo}
                    immAccounts={immAccounts}
                />
            );
        } else if (immCardCharge.get('blockFlow')) {
            bodyContent = <CardChargeErrorStep immCard={immCard} />;
        } else {
            bodyContent = (
                <div>
                    <div className="col-xs-12 col-md-8">
                        <CardCharge
                            immAccounts={immAccounts}
                            immCard={immCard}
                            immCardCharge={immCardCharge}
                            validateStep={validateStep}
                            setVisibleStep={setVisibleStep}
                            setWillCancel={setWillCancel}
                            postChange={postChange}
                            isPeriodicTransfer={isPeriodicTransfer}
                        />
                    </div>
                    <div className="col-xs-12 col-md-4 grid-view--variable-cell-separation">
                        <CardDetailsSidebar immCard={immCard} />
                    </div>
                </div>
            );
        }

        return (
            <div>
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="cards" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                subtitleLeft={subtitleLeft}
                                subtitleRight={subtitleRight}
                                tutorial={tutorial}
                                finalTitle={titleEditable}>
                                <CardHeaderDetails
                                    immCard={immCard}
                                    isFetching={immCardCharge.get('isFetching')}
                                />
                            </OKHeaderSubPage>
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            {bodyContent}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

CardChargeEditView.propTypes = {
    clearRequest: PropTypes.func.isRequired,
    cardPeriodicLoads: PropTypes.object.isRequired,
    editCardChargeView: PropTypes.func.isRequired,
    getPeriodicLoadsList: PropTypes.func.isRequired,
    flagBasedFeatures: PropTypes.object,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immCardCharge: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    postChange: PropTypes.func.isRequired,
    requestECardInfo: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired
};

module.exports.constructor = CardChargeEditView;
module.exports.CardChargeEditView = connect(
    state => ({
        cardPeriodicLoads: state.cardPeriodicLoads,
        flagBasedFeatures: state.flagBasedFeatures,
        immAccounts: state.accounts,
        immCardCharge: state.cardCharge,
        immCards: state.cards
    }),
    {
        clearRequest: cardChargeActions.clearRequest,
        editCardChargeView: cardChargeActions.editCardChargeView,
        getPeriodicLoadsList: cardPeriodicLoadsActions.getPeriodicLoadsList,
        postChange: cardChargeActions.postChange,
        requestECardInfo: cardChargeActions.requestECardInfo,
        setVisibleStep: cardChargeActions.setVisibleStep,
        setWillCancel: cardChargeActions.setWillCancel,
        validateStep: cardChargeActions.validateStep
    }
)(withRouter(CardChargeEditView));
